<nav-bar [isCircle]="true"> </nav-bar>

<div *ngIf="showImport" class="container-import">
  <div class="import">
    <div class="header-content">
      <div class="title">
        <h3>Import Production File</h3>
      </div>
    </div>
    <div class="content-import">
      <div class="download-btn">
        <a
          href="assets/file/production layout (use csv please) - Sheet1.csv"
          download="template.csv"
          >Download .CSV Template</a
        >
      </div>
      <form
        action=""
        [formGroup]="uploadForm"
        #form="ngForm"
        (ngSubmit)="save()"
        novalidate
        class="upload-form"
      >
        <div *ngIf="!progressBarPopup" class="upload-file-content">
          <div class="d-block">
            <div *ngIf="!isUploaded" (click)="fetchFile()" class="upload-file">
              <input
                type="file"
                [allowedExt]="photoAllowedExt"
                #attachedFile
                [accept]="photoAllowedExt"
                (change)="uploadImage($event)"
                formControlName="records"
                [hidden]="true"
              />
              <div class="icon">
                <img src="./assets/images/plus-circle-dotted.svg" alt="" />
              </div>
              <span>Choose File To Upload</span>
            </div>
            <div *ngIf="isUploaded" class="file-info upload-file">
              <div class="file-name">{{ fileName }}</div>
              <div
                class="remove-file"
                (click)="deleteFile()"
                style="cursor: pointer"
              >
                <img src="./assets/images/trash2-fill.svg" alt="" />
              </div>
            </div>
          </div>
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="uploadForm.controls['records']"
          >
          </app-form-errors>
        </div>

        <div *ngIf="progressBarPopup" class="progress-bar-popup">
          <p class="content">
            Your CSV file has been successfully uploaded.
            <span
              >We are now processing the records. Please wait while we add them
              to the database.</span
            >
            <span class="cancel-queue" (click)="messageComponent.open()"
              >Cancel Import</span
            >
          </p>
          <div class="progress-bar">
            <p-progressBar [value]="progressBarInfo?.value"></p-progressBar>
          </div>
        </div>

        <div class="guidelines-container">
          <h2 class="title">Guide For Importing Contracts</h2>
          <div class="sub-title">
            To import contracts, you must create an Excel sheet that contains optional and required columns. 
            Use <a href="assets/file/production layout (use csv please) - Sheet1.csv" download="template.csv">this file (example file)</a> 
            to import the contracts and you can add and update data on this file.
          </div>
          <h3 class="template-fields-title">Template Fields</h3>
          <ul class="template-fields-list">
            <li>Dealer # – Varchar, Mandatory</li>
            <li>Contract# – Varchar, Mandatory</li>
            <li>VIN # – Varchar, Mandatory (example: 1gkb2gkc0hr323633)</li>
            <li>Plan Code – Varchar, Mandatory</li>
            <li>Rate Book ID – Number, Mandatory</li>
            <li>First Name – Varchar, Mandatory</li>
            <li>Last Name – Varchar, Mandatory</li>
            <li>Contract Sale Date – Date, Mandatory (YYYY-MM-DD)</li>
            <li>Contract Term (Mos.) – Number, Mandatory</li>
            <li>Contract Term in Mileage – Number, Mandatory</li>
            <li>Sale Odometer – Number, Mandatory</li>
            <li>Fund Status – Optional, must be exactly one of: Fully Funded, Not Funded, Over Funded, Under Funded (case-sensitive)</li>
            <li>TPA – Varchar, Optional</li>
            <li>Agent # – Varchar, Optional</li>
            <li>Register# – Varchar, Optional</li>
            <li>Title – Varchar, Optional</li>
            <li>Middle Name – Varchar, Optional</li>
            <li>Spouse – Varchar, Optional</li>
            <li>Address – Varchar, Optional</li>
            <li>City – Varchar, Optional</li>
            <li>State – Varchar, Optional</li>
            <li>Zip – Number, Optional</li>
            <li>Phone# – Number, Optional</li>
            <li>Work # – Number, Optional</li>
            <li>Contract Holder Extension 1 – Varchar, Optional</li>
            <li>Extension 2 – Varchar, Optional</li>
            <li>Contract Hldr Email – Email, Optional</li>
            <li>Vehicle Yr – Number, Optional</li>
            <li>Mfg Warranty Term (months) – Number, Optional</li>
            <li>Mfg Mileage – Number, Optional</li>
            <li>Vehicle Auto Code – Varchar, Optional</li>
            <li>Leinholder # – Varchar, Optional</li>
            <li>Reinsurance ID – Varchar, Optional</li>
            <li>Veh In Svc Dt (req only new) – Date, Optional (required only for new vehicles)</li>
            <li>Member ID – Varchar, Optional</li>
            <li>No Charge Back – Boolean, Optional</li>
            <li>Contract Entry Dt – Date, Optional</li>
            <li>N / U – Varchar, Optional ("N" = New, "U" = Used)</li>
            <li>Deductible Amount – Number, Optional</li>
            <li>Deductible Type – Varchar, Optional</li>
            <li>Language (EN default) – Varchar, Optional (default: EN)</li>
            <li>Retail Rate – Amount ($), Optional</li>
            <li>slien Name – Varchar, Optional</li>
            <li>slien adrs – Varchar, Optional</li>
            <li>slien adrs2 – Varchar, Optional</li>
            <li>slien city – Varchar, Optional</li>
            <li>slien state – Varchar, Optional</li>
            <li>slien zip – Varchar, Optional</li>
            <li>slien phone – Number, Optional</li>
            <li>slien contract – Varchar, Optional</li>
            <li>slien fed tax id – Varchar, Optional</li>
            <li>scontract entry app name – Varchar, Optional</li>
            <li>Pymt option – Varchar, Optional</li>
            <li>Deal Type – Varchar, Optional</li>
            <li>APR – Percentage (%), Optional</li>
            <li>Term – Number, Optional</li>
            <li>Monthly Payment – Amount ($), Optional</li>
            <li>First Payment Date – Date, Optional</li>
            <li>Balloon Amount – Amount ($), Optional</li>
            <li>MSRP – Amount ($), Optional</li>
            <li>Base ACV – Amount ($), Optional</li>
            <li>Fortegra – Amount ($), Optional</li>
            <li>Reserves – Amount ($), Optional</li>
            <li>Clip Fee – Amount ($), Optional</li>
            <li>Premium Tax – Amount ($), Optional</li>
            <li>Batch Number – Varchar, Optional</li>
            <li>Batch Description – Varchar, Optional</li>
            <li>Status – Varchar, Optional (case-insensitive). Allowed values:
              <ul>
                <li>new</li>
                <li>approved</li>
                <li>draft</li>
                <li>pending</li>
                <li>active</li>
                <li>cancelled</li>
                <li>expired</li>
                <li>void</li>
                <li>pending funding</li>
                <li>paid</li>
                <li>past due</li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="footer-form">
          <button
            class="cancel-btn"
            type="button"
            [disabled]="loadingSubmit"
            (click)="back()"
          >
            Back
          </button>
          <button
            *ngIf="!progressBarPopup"
            [disabled]="loadingSubmit"
            type="submit"
            class="create-btn custom-btn"
          >
            Import Now
            <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- confirmation message -->
<app-confirmation-msg
  #messageComponent
  [isLoading]="loadingSubmit"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Do you want to cancel import production file?'"
>
</app-confirmation-msg>
